var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',{domProps:{"textContent":_vm._s(_vm.header.text)}}),_c('v-icon',_vm._g(_vm._b({attrs:{"size":"16","color":"info","right":""}},'v-icon',attrs,false),on),[_vm._v("mdi-information")])]}}])},[_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.header.hint),expression:"header.hint"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }